import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { ShopOA } from '@etop/models';
import { ZOAConnectionStore, StateZOAConnection } from './oa-connection.store';

@Injectable({
  providedIn: 'root',
})
export class OAConnectionQuery extends QueryEntity<StateZOAConnection, ShopOA> {
  constructor(protected store: ZOAConnectionStore) {
    super(store);
  }

  get currentUi() {
    return this.getValue().ui;
  }
}
 